import {
  FETCH_REFUNDABLE_ITEMS_LIST,
  RESET_REFUNDABLE_ITEMS_LIST,
} from "../../constants/action.constants";

//Storage for data.
const initialState = {
  list: [],
  others: {
    total: 0,
    offset: 0,
    limit: 10,
  },
};

//Controller for the storage.
const refundableItemsListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REFUNDABLE_ITEMS_LIST:
      return { list: action.payload, others: action.others };
    case RESET_REFUNDABLE_ITEMS_LIST:
      return initialState;
    default:
      return state;
  }
};

export default refundableItemsListReducer;
